/**
 * True when running inside a Capacitor native shell (iOS/Android).
 * In a pure web build (production or preview on noteornot.com) this is always false,
 * so callers fall back to the normal proxied endpoints.
 */
export function isNativePlatform(): boolean {
  if (typeof window === "undefined") return false;
  const cap = (window as unknown as { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor;
  return !!cap?.isNativePlatform?.();
}
